export default __webpack_public_path__ + "static/media/pills.342f0017.png";